import styled from "styled-components";

const Wrapper = styled.div`
  .user-search {
    width: 320px;
  }

  .users-error {
    margin-bottom: 16px;
  }
  .search-row {
    margin-bottom: 16px;
  }

  .table-link {
    padding: 0;
  }

  .invitations-table {
    margin-bottom: 28px;
  }

  .drawer-section-title {
    margin-top: 24px;
  }
`;

export default Wrapper;
